import React from 'react';
import { makeStyles, Tooltip } from '@material-ui/core';
import { designTokens } from '../../../styles/designTokens';
import { FILTER_CONFIG } from '../utils/filterConfig';
import { parseServices } from '../utils/formatters';

const useStyles = makeStyles({
    container: {
        display: 'flex',
        gap: designTokens.spacing.xs,
        flexWrap: 'wrap',
        alignItems: 'center',
    },
    icon: {
        width: '32px',
        height: '32px',
        objectFit: 'contain',
    },
    tooltip: {
        backgroundColor: designTokens.colors.primary,
        fontSize: '12px',
    },
    arrow: {
        color: designTokens.colors.primary,
    }
});

/**
 * Компонент відображення іконок сервісів пункту
 * @param {Object} props
 * @param {string} props.services - Рядок сервісів типу "{paycard,online}"
 */
const ServiceIcons = ({ services }) => {
    const classes = useStyles();
    const serviceList = parseServices(services);

    const availableServices = FILTER_CONFIG.filter(filter =>
        serviceList.includes(filter.optKey)
    );

    if (availableServices.length === 0) {
        return null;
    }

    return (
        <div className={classes.container}>
            {availableServices.map(filter => (
                <Tooltip
                    key={filter.id}
                    title={filter.label}
                    arrow
                    placement='top-end'
                    classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                >
                    <img
                        src={filter.icon}
                        alt={filter.label}
                        className={classes.icon}
                    />
                </Tooltip>
            ))}
        </div>
    );
};

export default ServiceIcons;
